module.exports = __webpack_public_path__ + "img/visit-seth.066b8579.svg";